import { Module } from "vuex";

import mutations from "./mutations";
import actions from "./actions";
import getters from "./getters";

import { IGraphicsControllerStoreState } from "@/libs/graphics/types/Graphics.t";

const graphicsControllerModule: Module<IGraphicsControllerStoreState, any> = {
  mutations,
  actions,
  getters,
  state: {
    activeGraphic: null,
    activeGraphicViewbox: { x: 0, y: 0 },
    graphicSetting: [],
    editorVisible: false,
    placementSetting: [],
    graphicUGCSetting: [],
    outOfBoundsModalShownInfo: {},
    originalGraphicViewbox: {}
  },
  namespaced: true,
};

export default graphicsControllerModule;
